import React, { useState, useEffect, useRef } from 'react';
import Modal from './Modal';
import Button from './Button';
import apiClient from '../../utils/apiClient';

export default function OtpModal({ open, onClose, email, action, tradeId = null, onConfirm }) {
  const [code, setCode]             = useState('');
  const [sending, setSending]       = useState(false);
  const [sent, setSent]             = useState(false);
  const [error, setError]           = useState('');
  const [secondsLeft, setSecondsLeft] = useState(0);
  const timerRef = useRef(null);

  const startResendTimer = () => {
    setSecondsLeft(60);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setSecondsLeft(s => {
        if (s <= 1) { clearInterval(timerRef.current); return 0; }
        return s - 1;
      });
    }, 1000);
  };

  const sendCode = async () => {
    setSending(true); setError('');
    try {
      await apiClient.post('/otp/send', { email, action, tradeId });
      setSent(true);
      startResendTimer();
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to send code. Please try again.');
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    if (open) {
      setCode(''); setError(''); setSent(false);
      sendCode();
    }
    return () => clearInterval(timerRef.current);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleConfirm = () => {
    if (code.length !== 6) { setError('Enter the full 6-digit code'); return; }
    setError('');
    onConfirm(code);
  };

  const label = action === 'p2p_release' ? 'escrow release' : action === 'password_reset' ? 'password reset' : 'phone number change';
  const maskedEmail = email
    ? email.replace(/^(.{2})(.*)(@.*)$/, (_, a, b, c) => a + '*'.repeat(Math.max(1, b.length)) + c)
    : '';

  return (
    <Modal open={open} onClose={onClose} title="Verify It's You">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <p style={{ color: '#8B8FA8', fontSize: '13px', lineHeight: 1.7, margin: 0 }}>
          {sent
            ? <>We sent a 6-digit code to <strong style={{ color: '#fff' }}>{maskedEmail}</strong> to confirm your {label}. Check your inbox — it expires in 15 minutes.</>
            : <span style={{ color: '#4B5170' }}>Sending code…</span>}
        </p>

        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          placeholder="000000"
          className="input"
          style={{ textAlign: 'center', fontSize: '28px', letterSpacing: '10px', fontWeight: 800, fontVariantNumeric: 'tabular-nums' }}
          value={code}
          onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          onKeyDown={e => e.key === 'Enter' && handleConfirm()}
          autoFocus
        />

        {error && <p style={{ color: '#EF4444', fontSize: '13px', margin: 0 }}>{error}</p>}

        <Button variant="primary" size="lg" full onClick={handleConfirm} disabled={!sent || code.length !== 6}>
          Confirm
        </Button>

        <button
          onClick={sendCode}
          disabled={sending || secondsLeft > 0}
          style={{
            background: 'none', border: 'none', padding: '4px 0', fontSize: '13px',
            cursor: secondsLeft > 0 ? 'not-allowed' : 'pointer',
            color: secondsLeft > 0 ? '#4B5170' : '#7C5CF6',
          }}
        >
          {sending ? 'Sending…' : secondsLeft > 0 ? `Resend code in ${secondsLeft}s` : 'Resend code'}
        </button>
      </div>
    </Modal>
  );
}
